import { dailySessionNotes } from '../../actions/constant';

const {
  GET_OTHER_PATIENT_DAILY_SESSION_FAILURE,
  GET_OTHER_PATIENT_DAILY_SESSION_SUCCESS,
  GET_OTHER_PATIENT_DAILY_SESSION_LOADING,
  RESET_OTHER_PATIENT_DAILY_SESSION,
} = dailySessionNotes;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
  loading: false,
};

export const getDailySessionOtherPatientList = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_OTHER_PATIENT_DAILY_SESSION_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_OTHER_PATIENT_DAILY_SESSION_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };
    case GET_OTHER_PATIENT_DAILY_SESSION_LOADING:
      return {
        ...state,
        loading: true,
      };
    case RESET_OTHER_PATIENT_DAILY_SESSION:
      return intitialstate;
    default:
      return state;
  }
};
